<template>
  <div>
    <el-form class="page-panel-search-form" :inline="true">
      <el-form-item class="page-panel-search-form-right-button">
        <el-button
          type="primary"
          @click="dialogVisable.memberDialog=true,leaderParam={},imageUrl=''"
        >新增</el-button>
      </el-form-item>
    </el-form>
    <ul class="article-list">
      <li class="article-list_item" v-for="item in leaderList" :key="item.expertId">
        <div class="article-list-item__body">
          <div class="article-list-item__info">
            <div class="cover" style="height: 210px;">
              <img
                :src="item.leadImg?item.leadImg:'/static/img/common/zwtp.png'"
                class="image"
                onerror="this.src='/static/img/common/zwtp.png'"
              />
            </div>
            <div class="article-content" v-html="item.leadBody"></div>
            <div class="article-control">
              <a
                href="javascript:;"
                class="article-control__item"
                type="text"
                @click="edit(item)"
              >编辑</a>
              <a
                href="javascript:;"
                class="article-control__item"
                type="text"
                @click="delLead(item)"
              >删除</a>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div class="page-panel__footer">
      <el-pagination
        :current-page.sync="searchModel.pageNo"
        :page-size="searchModel.pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog :title="addMemberTitle" :visible.sync="dialogVisable.memberDialog" width="40%">
      <el-form>
        <table class="form-editor">
          <tr>
            <th>领导姓名</th>
            <td>
              <el-input placeholder="请输入领导姓名" v-model="leaderParam.leadName"></el-input>
            </td>
          </tr>
          <tr>
            <th>领导排序</th>
            <td>
              <el-input placeholder="请输入排序序号" v-model="leaderParam.leadOrder"></el-input>
            </td>
          </tr>
          <tr>
            <th>领导头像</th>
            <td>
              <el-upload
                class="avatar-uploader"
                action="/file/upload"
                :show-file-list="false"
                :on-success="uploadSuccess"
                :headers="headers"
              >
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </td>
          </tr>
          <tr>
            <th>专家简介</th>
            <td>
              <!-- <ueditor :config="editorConfig" v-model="leaderParam.leadBody"></ueditor> -->
              <!-- <qeditor :content.sync="leaderParam.leadBody"></qeditor> -->
              <editor v-model="leaderParam.leadBody" :min-height="200" />
            </td>
          </tr>
        </table>
      </el-form>
      <span slot="footer">
        <el-button @click=" dialogVisable.memberDialog= false">取消</el-button>
        <el-button type="primary" @click="update">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="查看专家会员信息" :visible.sync="dialogVisable.memberDetailDialog" width="30%">
      <el-form>
        <table class="form-editor">
          <tr>
            <th>会员姓名</th>
            <td>{{leaderParam.expertName}}</td>
          </tr>
          <tr>
            <th>荣誉</th>
            <td>{{leaderParam.expertHonor}}</td>
          </tr>
          <tr>
            <th>专家简介</th>
            <td>
              <p v-html="leaderParam.expertText"></p>
            </td>
          </tr>
          <tr>
            <th>专家排序</th>
            <td>{{leaderParam.expertSort}}</td>
          </tr>
          <tr>
            <th>是否推荐</th>
            <td>
              <el-radio-group v-model="leaderParam.expertRecommend" disabled>
                <el-radio :label="0">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </td>
          </tr>
          <tr>
            <th>会员照片</th>
            <td>
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            </td>
          </tr>
        </table>
      </el-form>
      <span slot="footer">
        <el-button @click=" dialogVisable.memberDialog= false">取消</el-button>
        <el-button type="primary">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { localStorage } from '@/common/util/storage';
import * as leaderApi from '@/api/adminApi/zh/leader';
export default {
  data() {
    return {
      headers: {
        token: localStorage.get('token')
      },
      editorConfig: {
        initialFrameWidth: '100%',
        initialFrameHeight: 300,
        zIndex: 0
      },
      addMemberTitle: '新增领导',
      dialogVisable: { memberDialog: false, memberDetailDialog: false },
      leaderParam: {
        expertRecommend: 0
      },
      imageUrl: '',
      total: 6,
      leaderList: [],
      searchModel: {
        pageNo: 1,
        pageSize: 10
      }
    };
  },
  methods: {
    edit(row) {
      this.leaderParam = JSON.parse(JSON.stringify(row));
      this.imageUrl = this.leaderParam.leadImg;
      this.dialogVisable.memberDialog = true;
    },
    delLead(row) {
      this.$confirm('是否确认删除该领导信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          leaderApi.delLead({ leadId: row.leadId }).then(res => {
            this.getLeadList();
          });
        })
        .catch(action => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    },
    update() {
      if (this.leaderParam.leadId) {
        leaderApi.upLead(this.leaderParam).then(res => {
          this.getLeadList();
          this.dialogVisable.memberDialog = false;
        });
      } else {
        leaderApi.addLead(this.leaderParam).then(res => {
          this.getLeadList();
          this.dialogVisable.memberDialog = false;
        });
      }
    },
    initDialog() {
      this.getleaderList();
      this.imageUrl = '';
      this.leaderParam = {
        expertRecommend: 0
      };
      this.dialogVisable.memberDialog = false;
    },
    getLeadList() {
      leaderApi.getLeadList(this.searchModel).then(res => {
        this.leaderList = res.data.list;
      });
    },
    uploadSuccess(res, file, fileList) {
      this.leaderParam.leadImg = res.url;
      this.imageUrl = res.url;
    }
  },
  created() {
    this.getLeadList();
  }
};
</script>

<style lang="stylus" scoped>
.leader-list {
  padding: 0;
  margin: 0;

  li.leader-list_item {
    list-style: none;
    height: 200px;

    .leader_avatar {
      float: left;

      img {
        width: 130px;
        height: 200px;
      }
    }

    .leader_content {
      float: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/adminCenter/page/article/leader/list.vue